import { render, staticRenderFns } from "./InstalacionesStatusComponent.vue?vue&type=template&id=e24c12b2&"
import script from "./InstalacionesStatusComponent.vue?vue&type=script&lang=js&"
export * from "./InstalacionesStatusComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
